/**
 * @generated SignedSource<<3d8f412566f4c676cce0fdda7b5949e4>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type aiLimitGuardQuery$variables = Record<PropertyKey, never>;
export type aiLimitGuardQuery$data = {
  readonly checkAILimited: boolean;
};
export type aiLimitGuardQuery = {
  response: aiLimitGuardQuery$data;
  variables: aiLimitGuardQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "checkAILimited",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "aiLimitGuardQuery",
    "selections": (v0/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "aiLimitGuardQuery",
    "selections": (v0/*:: as any*/)
  },
  "params": {
    "cacheID": "bc43eab8a1fd93dd1bd66fa20e3a7689",
    "id": null,
    "metadata": {},
    "name": "aiLimitGuardQuery",
    "operationKind": "query",
    "text": "query aiLimitGuardQuery {\n  checkAILimited\n}\n"
  }
};
})();

(node as any).hash = "1758c6742b180c6c3f6904170f95531b";

export default node;
